import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'study-levels';

const StudyLevelService = {
  getPagedResult() {
    return Http.get(`/${RESOURCE_NAME}`);
  },
  getList() {
    return Http.get(`/${RESOURCE_NAME}`);
  },
  getListByStudent() {
    return Http.get(`/${RESOURCE_NAME}/list`);
  },
  create() {
    return Http.post(`/${RESOURCE_NAME}`);
  },
  del(id) {
    return Http.delete(`/${RESOURCE_NAME}/${id}`);
  },
};

export default StudyLevelService;
